import { createFileRoute } from "@tanstack/react-router"

// Route-depth MARKER: `/forms/$formId` activates the form-record column (col 2).
// The Forms LAYOUT route (forms.tsx) reads `$formId` from the leaf match and
// renders every column itself; this child just contributes the param + an
// <Outlet/> sink for the deeper `$responseId` child.
export const Route = createFileRoute("/$orgSlug/$eventSlug/forms/$formId")({
  component: () => null,
})
